import React from "react";
import "./MainContent.css";

const MainContent = () => (
  <main className="main-content">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
    />
    <h1>Every tool you need to work <br/> with PDFs in one place</h1>
    <p>
      Every tool you need to use PDFs, at your fingertips. All are 100% FREE and
      easy to use! Merge, split,<br/> compress, convert, rotate, unlock and
      watermark PDFs with just a few clicks.
    </p>
  </main>
);

export default MainContent;
